<template>
  <modal
    :name="modalCreate"
    :adaptive="true"
    :clickToClose="false"
    :reset="true"
    :scrollable="true"
    :height="'auto'"
    @closed="getList"
  >
    <div class="row">
      <div class="col-xl-8 col-lg-7 col-md-6 my-auto mx-auto">
        <card class="card" :title="modalTitle">
          <div>
            <form @submit.prevent>
              <div class="row">
                <div v-for="field in fields" :key="field.key" class="col-md-12">
                  <div v-if="field.type==='group'"> 
                          <div v-if="item[field.key]">Статус установлен</div>
                          <p-button
                            class="mx-1 btn-sm w-100 mb-4"
                            type="error"
                            @click.native.prevent="setGroup"
                            >  <span v-if="item[field.key]">Изменить статус</span> <span v-else>Установить статус</span> </p-button
                          >
                      <list-item 
                      :isAccept="true"
                       v-model="item[field.key]"
                       :modalName="{
                            model: 'group',
                            route: 'admin/clients/relate/group',
                          }"   />

                  </div>
                  <div v-else-if="field.type==='device'">
                          <radio-list
                                name="device"
                                :items="[{id:'iOS',title:'iOS (Apple)'}, {id:'Android' , title:'Android'}]"
                                v-model="item[field.key]"
                              />
                  </div>
             
                  <fg-input
                    v-else
                    type="text"
                    :label="field.label"
                    v-model="item[field.key]"
                  ></fg-input>
                </div>
              </div>
              <div class="text-center mb-2">
                <p-button
                  class="mx-1 btn-sm"
                  type="info"
                  @click.native.prevent="addItem"
                  >Добавить</p-button
                >
                <p-button
                  class="mx-1 btn-sm"
                  type="warning"
                  round
                  @click.native.prevent="$modal.hide(modalCreate)"
                  >Отмена</p-button
                >
              </div>
              <div class="clearfix"></div>
            </form>
          </div>
        </card>
      </div>
    </div>
  </modal>
</template>
<script>
import { errorNotify } from "@/plugins/functions";
import RadioList from "@/components/Filters/RadioList";
import ListItem from "@/components/Modals/ListItem";

export default {
  components:{
    ListItem,
    RadioList,
  },
  data() {
    return {
      item: {},
      group:null
    };
  },
  props: {
    setLink: {
      default: "",
    },
    modalTitle: {
      default: "Новый элемент",
    },
    modalCreate: {
      default: "",
    },
    fields: {
      type: Array,
      default: {
        function(prams) {
          return [];
        },
      },
    },
    getList: {
      type: Function,
      default: function () {},
    },
  },
  methods: {
    setGroup(){
        this.$modal.show('group');
    },
    addItem() {
      this.$loading(true);
      this.$http
        .post(this.setLink, this.item)
        .then((response) => {
          this.$modal.hide(this.modalCreate);
          this.item = {};
        })
        .catch((error) => {
          errorNotify(error, this);
        })
        .finally(() => {
          setTimeout(() => {
            this.$loading(false);
          }, 400);
               
        });
    },
  },
};
</script>